// extracted by mini-css-extract-plugin
export default {"container":"BonusPrize_container__LROaL","contents_box":"BonusPrize_contents_box__3TVzc","bonus_contents":"BonusPrize_bonus_contents__pBYbT"};